import React, { useEffect, useState } from "react";

//Import Breadcrumb
import { Grid } from "@mui/material";
import { connect, useDispatch } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { Container } from "reactstrap";
import Label from "../../components/Common/Label";
import LoadingDialog from "../../components/Common/LoadingDialog";
import Notification from "../../components/Common/Notification";
import Table from "../../components/Common/Table";
import TablePageControl from "../../components/Common/TablePageControl";
import CustomButton from "../../components/Form/CustomButton";
import CustomIconButton from "../../components/Form/CustomIconButton";
import CustomSelect2 from "../../components/Form/CustomSelect2";
import Helpers from "../../helpers/helpers";
import { deleteBanner, exportBanner, getBannerListing, resetBannerAttachmentState, resetBannerState, resetReviewDocumentState } from "../../store/actions";
import RenderPopOverButton from "../../components/Form/RenderPopOverButton.js";
import DeleteModal from "../../components/Common/DeleteModal.js";

const BannersManagement = ({ userPermission, bannerListing, deleteBannerItem, bannerExportDocument }) => {
    const dispatch = useDispatch()
    const navigate = useNavigate();

    useEffect(() => {
        dispatch(resetBannerState());
    }, []);

    const [loading, setIsLoading] = useState(false);
    const [checkedAll, setCheckedAll] = useState(false);
    const [filterObject, setFilterObject] = useState({ position: 'all', status: 'all', bannerType: 'all' });
    const [page, setPage] = useState("1");
    const [length, setLength] = useState("50");
    const [name, setSearch] = useState("");
    const [sort, setSorted] = useState("desc");
    const [sort_by, setSortBy] = useState("start");
    const [selectedRow, setSelectedRow] = useState();
    const [deleteOpen, setDeleteOpen] = useState(false);
    const [notification, setNotification] = useState({
        open: false,
        msg: "",
        type: "success",
    });
    const [exportable, setExportable] = useState(false);
    const [creatable, setCreatable] = useState(false);
    const [viewable, setViewable] = useState(false);
    const [editable, setEditable] = useState(false);
    const [deletable, setDeletable] = useState(false);

    useEffect(() => {
        if (userPermission?.length > 0) {
            userPermission?.includes("create-marketing") && setCreatable(true);
            userPermission?.includes("edit-marketing") && setEditable(true);
            userPermission?.includes("delete-marketing") && setDeletable(true);
            userPermission?.includes("export-marketing") && setExportable(true);
            !userPermission?.includes("view-marketing") && navigate('/not-authorized');
        }
    }, [userPermission]);

    useEffect(() => {
        initData();
    }, [length, page, sort, sort_by, filterObject]);

    useEffect(() => {
        if (deleteBannerItem?.code === 'success') {
            setDeleteOpen(false);
            setNotification({ open: true, msg: "Banner deleted successfully", type: "success" });
            dispatch(resetBannerState());
            setPage('1');
            initData();
        }
        setIsLoading(false);
    }, [deleteBannerItem])

    useEffect(() => {
        if (bannerExportDocument?.code === 'success' && bannerExportDocument?.excel_base64) {
            Helpers.handleDownloadExcelFile(bannerExportDocument.excel_base64, 'banner_listing');
            dispatch(resetReviewDocumentState());
            dispatch(resetBannerAttachmentState());
        }
        setIsLoading(false);
    }, [bannerExportDocument])

    const statusList = [
        { value: "all", label: "All statuses" },
        { value: "1", label: "Active" },
        { value: "0", label: "Inactive" }
    ]

    const positionList = [
        { value: "all", label: "All position" },
        { label: "HOME_TOP (Main hero section)", value: "HOME_TOP" },
        { label: "HOME_BANNER", value: "HOME_BANNER" },
        { label: "HOME_POPUP (Appears as a modal)", value: "HOME_POPUP" },
    ]

    const bannerTypeList = [
        { value: "all", label: "All banner type" },
        { label: "Static", value: "static" },
        { label: "Configurable", value: "configurable" },
    ]

    const header = [
        {
            Header: "Image",
            columnID: "image",
            accessor: (cellProps) => {
                return (
                    <React.Fragment>
                        <img src={cellProps?.image} alt="banner-image" style={{ height: "100px", width: '180px', objectFit: "contain" }} />
                    </React.Fragment>
                )
            },
            disableFilters: true,
            filterable: false,
        },
        {
            Header: "Banner type",
            columnID: "type",
            accessor: (cellProps) => {
                return (
                    <React.Fragment>
                        <div>{cellProps?.type ? cellProps.type.charAt(0).toUpperCase() + cellProps.type.slice(1) : '-'}</div>
                    </React.Fragment>
                )
            },
            disableFilters: true,
            filterable: false,
        },
        {
            Header: "Position",
            columnID: "position",
            accessor: (cellProps) => {
                return (<React.Fragment>{cellProps?.position || '-'}</React.Fragment>)
            },
            disableFilters: true,
            filterable: false,
        },
        {
            Header: "Starts on",
            columnID: "start",
            accessor: (cellProps) => {
                return (<React.Fragment>{cellProps?.start_at || '-'}</React.Fragment>)
            },
            disableFilters: true,
            filterable: false,
        },
        {
            Header: "Ends on",
            columnID: "end",
            accessor: (cellProps) => {
                return (<React.Fragment>{cellProps?.end_at || '-'}</React.Fragment>)
            },
            disableFilters: true,
            filterable: false,
        },
        {
            Header: "Status",
            columnID: "status",
            accessor: (cellProps) => {
                return (<React.Fragment><Label.StatusLabel label={cellProps.status} /></React.Fragment>)
            },
            disableFilters: true,
            filterable: false,
        },
        {
            Header: "Sort order",
            columnID: "sort_order",
            accessor: (cellProps) => {
                return (<React.Fragment>{cellProps?.sort_order || '0'}</React.Fragment>)
            },
            disableFilters: true,
            filterable: false,
        },
        {
            Header: "Action",
            accessor: (cellProps) => {
                return (
                    <React.Fragment>
                        {editable && <Link to={`/edit-banner/${cellProps.id}`}>
                            <CustomIconButton
                                iconName={'ri-pencil-line'}
                                onClick={() => { '' }}
                            />
                        </Link>}
                        <RenderPopOverButton
                            items={[{
                                iconName: 'ri-delete-bin-line',
                                label: 'Delete',
                                color: '#ED1A3D',
                                permission: deletable,
                                onClick: () => { setSelectedRow(cellProps); setDeleteOpen(true) }
                            }]}
                        />
                    </React.Fragment>
                )
            },
            minWidth: 120,
            position: 'sticky',
            disableFilters: true,
            filterable: false,
        }
    ]

    const initData = () => {
        dispatch(getBannerListing({
            page: page,
            size: length,
            status: filterObject?.status,
            position: filterObject?.position,
            type: filterObject?.bannerType === 'all' ? '' : filterObject?.bannerType,
            sort: sort,
            sort_by: sort_by,
            search: name
        }))
    }

    const resetFilter = () => {
        setPage("1");
        setFilterObject({ position: 'all', status: 'all', bannerType: 'all' });
        setSearch('');
    }

    const handleFilterChange = (key, value) => {
        setFilterObject((prevValues) => ({
            ...prevValues,
            [key]: value
        }));
    };

    const handleExport = () => {
        let filter = {
            status: filterObject?.status,
            position: filterObject?.position,
            type: filterObject?.bannerType,
            // search: name
        }
        Object.keys(filter).forEach(key => {
            if (!filter[key] || filter[key] === 'all') {
                delete filter[key];
            }
        });
        setIsLoading(true);
        dispatch(exportBanner({
            filter: filter,
            sort: sort_by,
            sort_order: sort,
            search: name
        }));
    }

    const handleDelete = () => {
        if (selectedRow?.id) {
            setIsLoading(true);
            dispatch(deleteBanner({ id: selectedRow.id }));
        }
    }

    const customToolsBar = () => {
        return (
            <Grid container rowSpacing={2} mb={0} paddingBlock={1}>
                <Grid container item lg={10} md={12} style={{ display: 'flex', alignItems: "center" }} spacing={1}>
                    <Grid item lg={3} md={3} xs={12}>
                        <CustomSelect2
                            values={filterObject?.bannerType || "-1"}
                            onChange={(e) => { setPage("1"); handleFilterChange('bannerType', e) }}
                            data={bannerTypeList}
                            placeholder={"All banner type"}
                        />
                    </Grid>
                    <Grid item lg={3} md={3} xs={12}>
                        <CustomSelect2
                            values={filterObject?.position || "-1"}
                            onChange={(e) => { setPage("1"); handleFilterChange('position', e) }}
                            data={positionList}
                            placeholder={"All position"}
                        />
                    </Grid>
                    <Grid item lg={3} md={3} xs={12}>
                        <CustomSelect2
                            values={filterObject?.status || "-1"}
                            onChange={(e) => { setPage("1"); handleFilterChange('status', e) }}
                            data={statusList}
                            placeholder={"All statuses"}
                        />
                    </Grid>
                    <Grid item lg={3} md={3} xs={12}>
                        <CustomButton
                            title={'Clear'}
                            press={() => resetFilter()}
                            height={32}
                            backgroundColor={'transparent'}
                            textColor={'#7BB9FA'}
                        />
                    </Grid>
                </Grid>
                {exportable && <Grid item lg={2} md={12} sx={{ display: 'flex', justifyContent: { lg: 'end', md: 'start' } }} alignItems={'center'}>
                    <CustomButton
                        title={<><i className="ri-download-2-line" style={{ marginRight: 5 }} />Export</>}
                        press={() => handleExport()}
                        height={32}
                        borderRadius={15}
                        borderStyle={"1px solid #babcbe"}
                    />
                </Grid>}
            </Grid>
        )
    }

    const renderHeader = () => {
        return (
            <div className="d-flex justify-content-between align-items-center p-1 pb-2">
                <div className="header d-flex">Banners <div className="header-amount mx-2">{bannerListing?.total || 0}</div></div>
                {
                    creatable &&
                    <CustomButton
                        title={<><i className="ri-add-line" style={{ marginRight: '5px' }} /> Add banner </>}
                        borderStyle={'1px solid #101010'}
                        backgroundColor={'#101010'}
                        textColor={'white'}
                        press={() => navigate('/add-banner')}
                    />
                }
            </div>
        )
    }

    return (
        <React.Fragment>
            <div className="page-content">
                <LoadingDialog open={loading || !bannerListing?.data} />
                <Container fluid>
                    <Notification notification={notification} setNotification={setNotification} />
                    {renderHeader()}
                    {customToolsBar()}
                    <Table
                        header={header}
                        data={bannerListing?.data || []}
                        pageSize={length}
                        totalPage={bannerListing?.last_page || 1}
                        customToolsBar={true}
                        sort={sort}
                        setSorted={setSorted}
                        sort_by={sort_by}
                        setSortBy={setSortBy}
                        setCheckedAll={setCheckedAll}
                        checkedAll={checkedAll}
                    />
                    <TablePageControl
                        length={length}
                        setLength={setLength}
                        page={page}
                        setPage={setPage}
                        totalPage={bannerListing?.last_page || 1}
                    />
                    <DeleteModal
                        open={deleteOpen}
                        close={() => setDeleteOpen(false)}
                        submit={() => handleDelete()}
                        module={'banner'}
                    />
                </Container>
            </div>
        </React.Fragment >
    );
};

function mapStateToProps({ Login, Banner }) {
    return {
        userPermission: Login.permissionArry,
        bannerListing: Banner.bannerListing,
        bannerExportDocument: Banner.exportBanner,
        deleteBannerItem: Banner.deleteBanner,
    };
}

export default connect(mapStateToProps)(BannersManagement);
